import {Component, Input, OnInit} from '@angular/core';
import {Website} from "../../website";
import {Product} from "../../product";
import {User} from "../../../../user/user";

@Component({
    selector: 'db-recreate-first-time',
    templateUrl: './recreate-first-time.component.html',
    styleUrls: ['./recreate-first-time.component.scss'],
    standalone: false
})
export class RecreateFirstTimeComponent implements OnInit {
  @Input() websiteId: number;
  @Input() user: User;
  @Input() website: Website;
  @Input() builderPlugin: Product;
  @Input() elementorPlugin: Product;
  @Input() forRecreateFirstTime: boolean;
  constructor() { }

  ngOnInit() {
  }

}
